export enum OrderTemporary {
  NONE = 'NONE',
  TEMPORARY = 'TEMPORARY',
  WAITING = 'WAITING',
  DONE = 'DONE',
}
